export default {
  data (){
    return {
      auth:{
        email:"",
        password:"",
      },
      loginbtnlabel:"ログイン",
      is_authnotmatch:false,
      is_authfail:false,
      signup:{
        first:"",
        family:"",
        email:"",
        password:""
      },
      signupbtnlabel:"登録する",
      is_signupconflict:false,
      is_signupconfail:false
    }
  },
  computed:{
    checkLogin (){
      if (this.auth.email && this.auth.password)
        return true
      else
        return false
    },
    checkSignup (){
      if (this.signup.first && this.signup.family && this.signup.email && this.signup.password.length>5)
        return true
      else
        return false
    }
  },
  methods:{
    login (){
      this.loginbtnlabel = "ログイン中...";
      this.is_authfail = false;
      this.is_authnotmatch = false;
      let data = {
        email:this.auth.email,
        password:this.auth.password,
        listitems:this.$store.state.listitems
      };
      this.$axios.post("/api/login", data)
      .then((response) => {
        let data = response.data;
        if(!this.ArrayCheck(this.$store.state.listitems.cart, data.listitems.cart)){
          this.$store.commit("auth", data);
          if(data.loggedin){
            this.$emit("cart-change")
            $("#cartchangeModal").modal("show");
          }else{
            this.is_authnotmatch = true;
            this.loginbtnlabel = "ログイン";
          }
        }else{
          this.$store.commit("auth", data);
          if(data.loggedin){
            console.log(data.role);
            this.$router.push(this.$route.query.next);
          }
          else{
            this.is_authnotmatch = true;
            this.loginbtnlabel = "ログイン";
          }
        }

      })
      .catch((e) => { 
        console.log(e.response);
        this.is_authfail = true;
        this.loginbtnlabel = "ログイン";
      });
    },
    SignupUser (e){
      this.signupbtnlabel = "登録中...";
      this.is_signupconflict = false;
      this.is_signupconfail = false;
      let payload = {
        email:this.signup.email,
        password:this.signup.password,
        first:this.signup.first,
        family:this.signup.family,
        listitems:this.$store.state.listitems
      };
      this.$axios.post("/api/signupuser", payload)
      .then((response) => {
          let data = response.data;
          if(data.loggedin){
            this.$store.commit("auth", data);
            $("#signupModal").modal("show");
          }else{
            this.is_signupconfail = true;
            this.signupbtnlabel = "登録する";
          }
      })
      .catch((error) => {
        console.log(error.response);
        if(error.response.status===409){
          this.is_signupconflict = true;
          this.signupbtnlabel = "登録する";
        }else{
          this.is_signupconfail = true;
          this.signupbtnlabel = "登録する";
        }
      });
    },
    ArrayCheck (a,b){
      var result = true;
      a.forEach(function(v,i,array){
        if (b.indexOf(v)<0)
            result = false;
      });
      b.forEach(function(v,i,array){
        if (a.indexOf(v)<0)
            result = false;
      });
      return result;
    },
    AfterSignup (){
      if (this.$route.path == "/cart")
        return
      if (this.$route.query.next)
        this.$router.push(this.$route.query.next);
      else
        this.$router.push("/mypage");
    }
  }
}